let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("2HU4O")).then(() => parcelRequire('4Mu1O'));